import { useEffect } from "react";

export const useProcessMicroCategories = (
  data,
  filters,
  handleFilterChange
) => {
  useEffect(() => {
    const searchApiResponse = data?.aggregationValue;

    if (data && searchApiResponse?.microcategory) {
      const existingMicroCategoriesMap = new Map(
        filters.microCategory?.map((cat) => [cat.name, cat])
      );

      // Process and update both new and existing microCategories
      searchApiResponse.microcategory
        .filter((cat) => cat?.bucketName !== "Inbox")
        .forEach((category) => {
          const categoryName = category.bucketName;
          existingMicroCategoriesMap.set(categoryName, {
            name: categoryName,
            docCount: category.docCount,
            checked: existingMicroCategoriesMap.has(categoryName)
              ? (
                  existingMicroCategoriesMap.get(categoryName) as {
                    checked: boolean;
                  }
                ).checked
              : true,
          });
        });

      handleFilterChange(
        "microCategory",
        Array.from(existingMicroCategoriesMap.values())
      );
    }
  }, [data?.aggregationValue]);
};
